// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19jwQ","list":"styles_list__3l8LD","disableSelection":"styles_disableSelection__l7NwL"};